import React, { useEffect, useState } from "react";
import { Modal } from "antd";
import { useSelector } from "react-redux";
import { selectIsMobileLayout } from "../../../../slices/MobileLayoutSlice";
import './couponModal.css';

import CouponInput from "../CouponInput/CouponInput";
import ExpandableOfferCard from "./ExpandableOfferCard";
import { ReactComponent as OfferTagIcon } from '../../../../assets/Offers/OfferTag.svg';
import TranslateText from "../../../resuableComponents/TranslateText";
import { CloseOutlined } from "@ant-design/icons";
import { offerListClosedEvent } from "../../../../Utils/uiAnalytics";

function CouponModal({ showModal, setShowModal, baseColor, appliedCoupon, handleToggleCoupon }) {

    const [filteredOfferList, setFilteredOfferList] = useState([])
    const offerList = useSelector(state => state.offers.offerList);
    const isMobileLayout = useSelector(selectIsMobileLayout);

    // Fired from every close path (mask click, close icon) before dismissing.
    const handleClose = () => {
        offerListClosedEvent();
        setShowModal(false);
    };
    const modalStyle = isMobileLayout
        ? {
            bottom: 0,
            margin: 0,
            padding: 0,
            // height: "700px",
            position: "absolute",
            width: "100%",
            // maxHeight: "700px",
            overflow: "scroll",
            top: "unset",
            maxWidth: "unset",
            scrollbarWidth: "none",
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
        }
        : undefined;

    useEffect(() => {
        if (!appliedCoupon?.code) {
            setFilteredOfferList(offerList);
            return;
        }
        const selectedOffer = offerList.find(el => el.code === appliedCoupon.code);
        const remainingOffers = offerList.filter(el => el.code !== appliedCoupon.code);
        setFilteredOfferList(
            selectedOffer ? [selectedOffer, ...remainingOffers] : offerList
        );
    }, [appliedCoupon, offerList]);

    return (
        <Modal
            open={showModal}
            footer={null}
            closable={false}
            width={isMobileLayout ? "100%" : "500px"}
            style={modalStyle}
            maskClosable
            onCancel={handleClose}
        >
            <div className="couponModalBody">
                <div className="couponHeader">
                    <article className="couponModalHeading" style={{ fontFamily: "Poppins" }}>
                        <OfferTagIcon style={{ color: baseColor }} />
                        <span className="semiBold20Heading">
                            <TranslateText label={"OFFERS"}>
                                Offers
                            </TranslateText>
                        </span>
                    </article>
                    <CloseOutlined className="close-icon"
                        data-testid="coupon-modal-close-btn"
                        onClick={handleClose}
                        style={{ cursor: "pointer" }} />
                </div>

                <div className="couponListContainer" style={{ marginBottom: "8px" }}>
                    <CouponInput
                        baseColor={baseColor}
                        handleToggleCoupon={handleToggleCoupon}
                        appliedCoupon={appliedCoupon}
                        isInModal={true}
                    />
                </div>

                <div className="couponListContainer">
                    {filteredOfferList?.length > 0 && filteredOfferList.map((offer) => (
                        <ExpandableOfferCard
                            key={offer.code}
                            handleToggleCoupon={handleToggleCoupon}
                            baseColor={baseColor}
                            isOfferApplied={appliedCoupon?.code === offer.code}
                            title={offer.title}
                            couponCode={offer.code}
                            offerData={offer}
                        />
                    ))}
                </div>
            </div>
        </Modal>
    );
}

export default CouponModal;
